import {useQuery} from '@tanstack/react-query';
import {getAuthService} from 'utilities';

/**
 * Hook to fetch user permissions (superuser, pilot user, sandbox access).
 * Caches the result for the lifetime of the session.
 */
export const useUserPermissions = () => {
  const {data, status, isLoading} = useQuery({
    queryKey: ['/user/permissions'],
    queryFn: () => getAuthService().getUserPermissionsApiV1UserPermissionsGet(),
    staleTime: Infinity, // Permissions don't change during a session
    retry: false,
  });

  return {
    status,
    isLoading,
    isSuperuser: data?.is_superuser ?? false,
    isPilotUser: data?.is_pilot_user ?? false,
    canAccessSandbox: data?.can_access_sandbox ?? false,
    isNamer: data?.is_namer ?? false,
    isNamerException: data?.is_namer_exception ?? false,
    namerExceptionList: data?.namer_exception_list ?? [],
    isColorado: data?.is_colorado ?? false,
  };
};
